import { useGetUser } from 'pages/Management/Users/hooks/useGetUser';
import { useParams } from 'react-router-dom';

export function UserBreadcrumb() {
  const { userId = '' } = useParams();
  const { user } = useGetUser(userId);

  return `${user.firstName} ${user.lastName}`;
}
